module.exports = __webpack_public_path__ + "~@/assets/img/oleg.5fc3fa42.png";